import React from "react";
import { GlobalSnackbar } from "./GlobalSnackbar";
import snackbarService, { ISnackbar, SnackbarMessageObserver, SnackbarMessageTypes } from "../ui-messaging/SnackbarService";

export const SnackbarContainer: React.FC = () => {
  const [snackbar, setSnackbar] = React.useState<ISnackbar>({
    message: { messageText: "", messageType: SnackbarMessageTypes.Info },
  });

  const onSnackbarUpdated: SnackbarMessageObserver = (props: ISnackbar) => {
    setSnackbar(props);
  };

  React.useEffect(() => {
    snackbarService.attach(onSnackbarUpdated);
    return () => snackbarService.detach(onSnackbarUpdated);
  });

  if (snackbar.message !== null) {
    return <GlobalSnackbar message={snackbar.message} seconds={snackbar.seconds} />;
  } else {
    return null;
  }
};
